
import Vue from "vue";
import { emitter, Notification, NotificationType } from "@/composables/emitter";

export default Vue.extend({
  data() {
    return {
      notifications: [] as Notification[],
      key: 0,
    };
  },
  mounted() {
    emitter.$on("notification", this.showNotification);
  },
  methods: {
    showNotification(notification: Notification) {
      this.notifications.push({ ...notification, id: this.key });
      const notificationId = this.key;
      setTimeout(() => {
        this.closeNotification(notificationId);
      }, 5000);
      this.key++;
    },

    closeNotification(notificationId: number | undefined) {
      const index = this.notifications.findIndex(
        (notification) => notification.id === notificationId
      );
      if (index !== -1) this.notifications.splice(index, 1);
    },
  },
});
